import { Bold, Italic, Underline, List } from "lucide-react";
import { Button } from "@/components/ui/button";

type SectionFormatting = {
    bold: boolean;
    italic: boolean;
    underline: boolean;
    list: boolean;
};

type FormattingResumeProps = {
    section: string;
    formatting?: SectionFormatting | null;
    setFormatting: (value: SectionFormatting) => void;
};

export function FormattingResume({
    section,
    formatting,
    setFormatting,
}: FormattingResumeProps) {
    const sectionStyle: SectionFormatting =
        formatting ?? {
            bold: false,
            italic: false,
            underline: false,
            list: false,
        };

    const toggle = (key: keyof SectionFormatting) => {
        const next = {
            ...sectionStyle,
            [key]: !sectionStyle[key],
        };

        setFormatting(next);
    };

    return (
        <div className=" flex gap-0 m-0 items-center">
            <div className="flex gap-1">
                {/* Bold */}
                <Button
                    variant={sectionStyle.bold ? "default" : "outline"}
                    size="icon"
                    onClick={() => toggle("bold")}
                    aria-label="Bold text"
                >
                    <Bold className="h-4 w-4" />
                </Button>

                {/* Italic */}
                <Button
                    variant={sectionStyle.italic ? "default" : "outline"}
                    size="icon"
                    onClick={() => toggle("italic")}
                    aria-label="Italic text"
                >
                    <Italic className="h-4 w-4" />
                </Button>

                {/* Underline */}
                <Button
                    variant={sectionStyle.underline ? "default" : "outline"}
                    size="icon"
                    onClick={() => toggle("underline")}
                    aria-label="Underline text"
                >
                    <Underline className="h-4 w-4" />
                </Button>

                {/* List */}
                <Button
                    variant={sectionStyle.list ? "default" : "outline"}
                    size="icon"
                    onClick={() => toggle("list")}
                    aria-label="Bullet list"
                >
                    <List className="h-4 w-4" />
                </Button>
            </div>
        </div>
    );
}
